document.addEventListener('scroll', () => {
    const priceDisRow = document.querySelector('.price-dis-row');
    const topPrice = window.innerWidth >= 990 ? document.querySelector('.product__title .price') : document.querySelector('.product-mobile-top .price');
    const bottomPrice = priceDisRow?.querySelector('.price');
    if (!priceDisRow || !topPrice || !bottomPrice) return;
    const rect = priceDisRow.getBoundingClientRect();
    const breakpoints = [
      { width: 1920, threshold: 260 },
      { width: 1440, threshold: 200 },
      { width: 1280, threshold: 180 },
      { width: 1028, threshold: 160 },
      { width: 750, threshold: 140 },
    ];
    for (const breakpoint of breakpoints) {
      if (window.innerWidth >= breakpoint.width) {
        if (rect.top <= breakpoint.threshold) {
          bottomPrice.style.display = 'none';
          topPrice.style.display = 'block';
        } else {
          bottomPrice.style.display = 'block';
          topPrice.style.display = 'none';
        }
        break;
      }
    }
  });  
window.addEventListener('resize', () => {
    const priceDisRow = document.querySelector('.price-dis-row');
    const topPrice = window.innerWidth >= 990 ? document.querySelector('.product__title .price') : document.querySelector('.product-mobile-top .price');
    const bottomPrice = priceDisRow.querySelector('.price');
    if (window.innerWidth < 750) {
        topPrice.style.display = 'block';
        bottomPrice.style.display = 'none';
        return;
    }else {
        topPrice.style.display = 'none';
        bottomPrice.style.display = 'block';
    }
});